import { render } from "./BotBookings.vue?vue&type=template&id=77077791"
import script from "./BotBookings.vue?vue&type=script&lang=js"
export * from "./BotBookings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__